import React, { useEffect, useState } from 'react';
import { Textarea } from '../../../shared/components/Textarea';
import { RecrutamentoModal } from './RecrutamentoModal';

interface MotivoModalProps {
  open: boolean;
  title: string;
  message: string;
  confirmLabel: string;
  /** Quando `false`, o motivo pode ir vazio. */
  required?: boolean;
  danger?: boolean;
  loading?: boolean;
  error?: string | null;
  onCancel: () => void;
  onConfirm: (motivo: string) => void;
}

/**
 * Confirmação que exige um motivo escrito.
 *
 * O `ConfirmDialog` compartilhado confirma sim/não; aqui o motivo é
 * parte do dado que o servidor grava (cancelamento de requisição,
 * reprovação de candidato), então não cabe um `window.prompt` nem um
 * campo solto na página.
 */
export function MotivoModal({
  open,
  title,
  message,
  confirmLabel,
  required = true,
  danger,
  loading,
  error,
  onCancel,
  onConfirm,
}: MotivoModalProps) {
  const [motivo, setMotivo] = useState('');
  const [touched, setTouched] = useState(false);

  useEffect(() => {
    if (open) {
      setMotivo('');
      setTouched(false);
    }
  }, [open]);

  const invalido = required && motivo.trim().length === 0;

  return (
    <RecrutamentoModal
      open={open}
      title={title}
      description={message}
      submitLabel={confirmLabel}
      submitVariant={danger ? 'danger' : 'primary'}
      cancelLabel="Voltar"
      isSubmitting={loading}
      submitError={error}
      canSubmit={!invalido}
      onClose={onCancel}
      onSubmit={() => {
        setTouched(true);
        if (invalido) return;
        onConfirm(motivo.trim());
      }}
    >
      <Textarea
        label={required ? 'Motivo (obrigatório)' : 'Motivo (opcional)'}
        rows={4}
        value={motivo}
        onChange={(event) => setMotivo(event.target.value)}
        onBlur={() => setTouched(true)}
        error={touched && invalido ? 'Informe o motivo.' : undefined}
      />
    </RecrutamentoModal>
  );
}
